import React, { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export interface LoadingConfig {
  background?: string;
  color?: string;
  size?: string;
}

const Loading: FC<LoadingConfig> = ({ background = '#19191e', color = '#ffffff', size = '80px' }) => {
  return (
    <Container style={{ background }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" width={size} height={size}>
        <style>
          {
            // eslint-disable-next-line max-len
            '@keyframes a0_t { 0% { transform: translate(53px,150px) scale(1,1) translate(-782.8px,-493.1px); } 45.455% { transform: translate(53px,150px) scale(.6,.6) translate(-782.8px,-493.1px); } 100% { transform: translate(53px,150px) scale(.6,.6) translate(-782.8px,-493.1px); } }\n@keyframes a1_o { 0% { opacity: 0; } 45.455% { opacity: 1; } 100% { opacity: 1; } }\n@keyframes a2_sw { 0% { stroke-width: 2px; } 45.455% { stroke-width: 16px; } 100% { stroke-width: 16px; } }\n@keyframes a3_t { 0% { transform: translate(119.7px,150px) scale(1,1) translate(-782.8px,-493.1px); } 18.182% { transform: translate(119.7px,150px) scale(1,1) translate(-782.8px,-493.1px); } 63.636% { transform: translate(119.7px,150px) scale(.6,.6) translate(-782.8px,-493.1px); } 100% { transform: translate(119.7px,150px) scale(.6,.6) translate(-782.8px,-493.1px); } }\n@keyframes a3_o { 0% { opacity: 0; animation-timing-function: steps(1); } 18.182% { opacity: 1; animation-timing-function: steps(1); } 100% { opacity: 0; } }\n@keyframes a4_o { 0% { opacity: 0; } 18.182% { opacity: 0; } 63.636% { opacity: 1; } 100% { opacity: 1; } }\n@keyframes a5_sw { 0% { stroke-width: 2px; } 18.182% { stroke-width: 2px; } 63.636% { stroke-width: 16px; } 100% { stroke-width: 16px; } }\n@keyframes a6_t { 0% { transform: translate(186.3px,150px) scale(1,1) translate(-782.8px,-493.1px); } 36.364% { transform: translate(186.3px,150px) scale(1,1) translate(-782.8px,-493.1px); } 81.818% { transform: translate(186.3px,150px) scale(.6,.6) translate(-782.8px,-493.1px); } 100% { transform: translate(186.3px,150px) scale(.6,.6) translate(-782.8px,-493.1px); } }\n@keyframes a6_o { 0% { opacity: 0; animation-timing-function: steps(1); } 36.364% { opacity: 1; animation-timing-function: steps(1); } 100% { opacity: 0; } }\n@keyframes a7_o { 0% { opacity: 0; } 36.364% { opacity: 0; } 81.818% { opacity: 1; } 100% { opacity: 1; } }\n@keyframes a8_sw { 0% { stroke-width: 2px; } 36.364% { stroke-width: 2px; } 81.818% { stroke-width: 16px; } 100% { stroke-width: 16px; } }\n@keyframes a9_t { 0% { transform: translate(252.8px,150px) scale(1,1) translate(-782.8px,-493.1px); } 54.545% { transform: translate(252.8px,150px) scale(1,1) translate(-782.8px,-493.1px); } 100% { transform: translate(252.8px,150px) scale(.6,.6) translate(-782.8px,-493.1px); } }\n@keyframes a9_o { 0% { opacity: 0; animation-timing-function: steps(1); } 54.545% { opacity: 1; animation-timing-function: steps(1); } 100% { opacity: 1; } }\n@keyframes a10_o { 0% { opacity: 0; } 54.545% { opacity: 0; } 100% { opacity: 1; } }\n@keyframes a11_sw { 0% { stroke-width: 2px; } 54.545% { stroke-width: 2px; } 100% { stroke-width: 16px; } }'
          }
        </style>
        <g
          transform="translate(53,150) translate(-782.8,-493.1)"
          style={{
            animation: '.88s linear infinite both a0_t',
          }}
        >
          <g
            opacity={0}
            transform="translate(783.4,493.2)"
            style={{
              animation: '.88s linear infinite both a1_o',
            }}
          >
            <path
              fill="none"
              /* eslint-disable-next-line max-len */
              d="M17.1 7.6c-0.5 .5-0.9 1-1.5 1.5c0 0 0 .1 0 .1c-2.9 2.9-6.3 5.2-9.9 7.2c-3.3 1.9-6.8 3.5-10.5 4.5c-0.1 0-0.1 0-0.2 0c-0.5 .2-1 .3-1.4 .4c-7.5 1.6-11.2-0.4-13.6-7.5c-0.2-0.7-0.4-1.3-0.6-2c0-0.1 0-0.1 0-0.1c-1.1-4-1.4-8.1-1.3-12.2c0-3.8 .4-7.6 1.4-11.3c0-0.1 0-0.1 0-0.2c.2-0.5 .3-1 .5-1.4c2.3-7.3 5.9-9.5 13.2-8c.7 .1 1.4 .3 2 .5c.1 0 .1 0 .1 0c4 1.1 7.7 2.8 11.2 5c3.3 1.8 6.4 4.1 9.1 6.8c.1 .1 .1 .1 .2 .2c.3 .3 .7 .7 1 1c5.1 5.7 5.2 9.9 .3 15.5Z"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              style={{
                animation: '.88s linear infinite both a2_sw',
              }}
            />
          </g>
        </g>
        <g
          opacity={0}
          transform="translate(119.7,150) translate(-782.8,-493.1)"
          style={{
            animation: '.88s linear infinite both a3_t, .88s linear infinite both a3_o',
          }}
        >
          <g
            opacity={0}
            transform="translate(783.4,493.2)"
            style={{
              animation: '.88s linear infinite both a4_o',
            }}
          >
            <path
              fill="none"
              /* eslint-disable-next-line max-len */
              d="M17.1 7.6c-0.5 .5-0.9 1-1.5 1.5c0 0 0 .1 0 .1c-2.9 2.9-6.3 5.2-9.9 7.2c-3.3 1.9-6.8 3.5-10.5 4.5c-0.1 0-0.1 0-0.2 0c-0.5 .2-1 .3-1.4 .4c-7.5 1.6-11.2-0.4-13.6-7.5c-0.2-0.7-0.4-1.3-0.6-2c0-0.1 0-0.1 0-0.1c-1.1-4-1.4-8.1-1.3-12.2c0-3.8 .4-7.6 1.4-11.3c0-0.1 0-0.1 0-0.2c.2-0.5 .3-1 .5-1.4c2.3-7.3 5.9-9.5 13.2-8c.7 .1 1.4 .3 2 .5c.1 0 .1 0 .1 0c4 1.1 7.7 2.8 11.2 5c3.3 1.8 6.4 4.1 9.1 6.8c.1 .1 .1 .1 .2 .2c.3 .3 .7 .7 1 1c5.1 5.7 5.2 9.9 .3 15.5Z"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              style={{
                animation: '.88s linear infinite both a5_sw',
              }}
            />
          </g>
        </g>
        <g
          opacity={0}
          transform="translate(186.3,150) translate(-782.8,-493.1)"
          style={{
            animation: '.88s linear infinite both a6_t, .88s linear infinite both a6_o',
          }}
        >
          <g
            opacity={0}
            transform="translate(783.4,493.2)"
            style={{
              animation: '.88s linear infinite both a7_o',
            }}
          >
            <path
              fill="none"
              /* eslint-disable-next-line max-len */
              d="M17.1 7.6c-0.5 .5-0.9 1-1.5 1.5c0 0 0 .1 0 .1c-2.9 2.9-6.3 5.2-9.9 7.2c-3.3 1.9-6.8 3.5-10.5 4.5c-0.1 0-0.1 0-0.2 0c-0.5 .2-1 .3-1.4 .4c-7.5 1.6-11.2-0.4-13.6-7.5c-0.2-0.7-0.4-1.3-0.6-2c0-0.1 0-0.1 0-0.1c-1.1-4-1.4-8.1-1.3-12.2c0-3.8 .4-7.6 1.4-11.3c0-0.1 0-0.1 0-0.2c.2-0.5 .3-1 .5-1.4c2.3-7.3 5.9-9.5 13.2-8c.7 .1 1.4 .3 2 .5c.1 0 .1 0 .1 0c4 1.1 7.7 2.8 11.2 5c3.3 1.8 6.4 4.1 9.1 6.8c.1 .1 .1 .1 .2 .2c.3 .3 .7 .7 1 1c5.1 5.7 5.2 9.9 .3 15.5Z"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              style={{
                animation: '.88s linear infinite both a8_sw',
              }}
            />
          </g>
        </g>
        <g
          opacity={0}
          transform="translate(252.8,150) translate(-782.8,-493.1)"
          style={{
            animation: '.88s linear infinite both a9_t, .88s linear infinite both a9_o',
          }}
        >
          <g
            opacity={0}
            transform="translate(783.4,493.2)"
            style={{
              animation: '.88s linear infinite both a10_o',
            }}
          >
            <path
              fill="none"
              /* eslint-disable-next-line max-len */
              d="M17.1 7.6c-0.5 .5-0.9 1-1.5 1.5c0 0 0 .1 0 .1c-2.9 2.9-6.3 5.2-9.9 7.2c-3.3 1.9-6.8 3.5-10.5 4.5c-0.1 0-0.1 0-0.2 0c-0.5 .2-1 .3-1.4 .4c-7.5 1.6-11.2-0.4-13.6-7.5c-0.2-0.7-0.4-1.3-0.6-2c0-0.1 0-0.1 0-0.1c-1.1-4-1.4-8.1-1.3-12.2c0-3.8 .4-7.6 1.4-11.3c0-0.1 0-0.1 0-0.2c.2-0.5 .3-1 .5-1.4c2.3-7.3 5.9-9.5 13.2-8c.7 .1 1.4 .3 2 .5c.1 0 .1 0 .1 0c4 1.1 7.7 2.8 11.2 5c3.3 1.8 6.4 4.1 9.1 6.8c.1 .1 .1 .1 .2 .2c.3 .3 .7 .7 1 1c5.1 5.7 5.2 9.9 .3 15.5Z"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              style={{
                animation: '.88s linear infinite both a11_sw',
              }}
            />
          </g>
        </g>
      </svg>
    </Container>
  );
};

export default Loading;
